import APP_CONFIG from '@/config/app.config'
import { logger } from '@/utils/logger';

export const resolveAssetUrl = (url) => {
  if (!url || typeof url !== 'string') {
    logger.error('[MEDIA] Invalid asset URL', { url })
    return ''
  }
  const trimmed = url.trim()
  if (trimmed.startsWith('/api/proxy/')) {
    return trimmed
  }
  const origin = APP_CONFIG.api.origin
  const isProd = process.env.NODE_ENV === 'production'

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const parsed = new URL(trimmed)
      if (parsed.pathname.startsWith('/api/proxy/')) {
        return `${parsed.pathname}${parsed.search}`
      }
      if (origin && parsed.origin === origin) {
        // Route backend-hosted assets through the frontend proxy so Next image
        // optimization never tries to fetch localhost/private IPs directly.
        return `/api/proxy/__raw__${parsed.pathname}${parsed.search}`
      }
    } catch {
      return trimmed
    }
    return trimmed
  }
  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`
  }

  if (trimmed.startsWith('/uploads/')) {
    if (!origin) {
      logger.error('[MEDIA] Missing API origin for upload asset resolution', { url: trimmed })
      return ''
    }
    if (isProd && origin.includes('localhost')) {
      logger.error('[MEDIA] Refusing to use localhost origin in production', { origin, url: trimmed })
      return ''
    }
    // Keep the asset same-origin to the frontend by proxying backend uploads.
    return `/api/proxy/__raw__${trimmed}`
  }

  // Frontend public assets should stay on the Next.js origin.
  return trimmed
}

export const resolveCategoryImageUrl = (category = {}) => {
  const slug = String(category?.slug || '').toLowerCase();
  const name = String(category?.name || '').toLowerCase();
  const rawImage = category?.imageUrl || category?.image || category?.iconUrl || '';

  if (
    ['brake-parts', 'brake-system'].includes(slug) ||
    ['brake parts', 'brake system'].includes(name) ||
    String(rawImage).includes('/icons/brakes.svg')
  ) {
    return '/brake_system_category.png';
  }

  return rawImage ? resolveAssetUrl(rawImage) : '';
};

export const resolveProductImages = (images = []) => {
  if (!Array.isArray(images)) return []
  return images
    .map((image) => {
      if (!image) return ''
      const url =
        typeof image === 'string'
          ? image
          : image.url || image.imageUrl || image.src || ''
      return resolveAssetUrl(url)
    })
    .filter(Boolean)
}
